module.exports = __webpack_public_path__ + "static/garda_main_1-8b98131519ff1ebb36505d912e8a8eb4.png";